import React from 'react';

const MetricCard = ({ icon, title, value, color }) => {
  const themeClasses = {
    blue: {
      bg: 'from-blue-500/10 to-indigo-500/5',
      iconBg: 'bg-blue-500 text-white shadow-lg shadow-blue-500/20',
      border: 'border-blue-500/20 hover:border-blue-500/40',
      glow: 'shadow-blue-500/5'
    },
    green: {
      bg: 'from-emerald-500/10 to-teal-500/5',
      iconBg: 'bg-emerald-500 text-white shadow-lg shadow-emerald-500/20',
      border: 'border-emerald-500/20 hover:border-emerald-500/40',
      glow: 'shadow-emerald-500/5'
    },
    purple: {
      bg: 'from-purple-500/10 to-fuchsia-500/5',
      iconBg: 'bg-purple-500 text-white shadow-lg shadow-purple-500/20',
      border: 'border-purple-500/20 hover:border-purple-500/40',
      glow: 'shadow-purple-500/5'
    },
    orange: {
      bg: 'from-orange-500/10 to-amber-500/5',
      iconBg: 'bg-orange-500 text-white shadow-lg shadow-orange-500/20',
      border: 'border-orange-500/20 hover:border-orange-500/40',
      glow: 'shadow-orange-500/5'
    }
  }[color] || {
    bg: 'from-slate-500/10 to-slate-500/5',
    iconBg: 'bg-slate-500 text-white shadow-lg shadow-slate-500/20',
    border: 'border-slate-200 hover:border-slate-300',
    glow: ''
  };

  return (
    <div className={`relative overflow-hidden bg-white/90 backdrop-blur-md rounded-xl sm:rounded-2xl border ${themeClasses.border} p-2 sm:p-4 md:p-6 shadow-md ${themeClasses.glow} hover:shadow-xl hover:scale-[1.02] transition-all duration-300 flex flex-col justify-between group`}>
      {/* Glow highlight */}
      <div className="absolute top-0 left-0 w-full h-[3px] bg-gradient-to-r from-blue-500/40 to-purple-500/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      <div className="flex items-center justify-between">
        <div className="min-w-0 pr-2">
          <p className="text-[9px] sm:text-xs font-bold text-slate-400 uppercase tracking-wider font-sans truncate">{title}</p>
          <p className="text-base sm:text-2xl md:text-3xl font-black text-slate-800 tracking-tight font-sans mt-0.5 sm:mt-1 md:mt-2 truncate">{value}</p>
        </div>
        <div className={`p-1.5 sm:p-3 md:p-3.5 rounded-lg sm:rounded-xl ${themeClasses.iconBg} transform group-hover:scale-110 transition-transform duration-300 flex items-center justify-center flex-shrink-0`}>
          {icon}
        </div>
      </div>
    </div>
  );
};

export default MetricCard;
